import { datadogRum } from '@datadog/browser-rum';
import DD_OPTIONS from '@ecs-na/tng-common/scripts/data-dog-options';
import { GatsbyBrowser } from 'gatsby';

// Add 'mobile-app-view' class to the body tag if the 'pc' query string parameter is present or if 'pc' is in session storage and contains 'map_exp_'
const addBodyClass = () => {
  const { body } = document;
  const queryParams = new URLSearchParams(window.location.search);
  const pc = queryParams.get('pc') || sessionStorage.getItem('pc');

  if (pc && pc.includes('map_exp_')) {
    if (!body.classList.contains('mobile-app-view')) {
      body.classList.add('mobile-app-view');
    }
    sessionStorage.setItem('pc', pc);
  }
};
const setWindowVars = () => {
  window.ecs_vertical = document.body.getAttribute('data-section');
  window.ecs_category = document.body.getAttribute('data-ecscategory');
  // console.log('window.ecs_vertical: ' + window.ecs_vertical);
  // console.log('window.ecs_category: ' + window.ecs_category);
};
export const onInitialClientRender = () => {
  // setWindowVars();
  // console.log('onInitialClientRender');
  // add custom event to window to signal t&t that React hydration is complete
  const event = new CustomEvent('gatsbyHydrationComplete', {
    bubbles: true,
    cancelable: false
  });
  window.dispatchEvent(event);
  window.gatsbyHydrationComplete = true;

  addBodyClass();
  // run dataDog script
  if (process.env.GATSBY_ENV !== 'development' && datadogRum) {
    datadogRum.init(DD_OPTIONS);
    datadogRum.startSessionReplayRecording();
  }
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  if (prevLocation && location && location !== prevLocation) {
    // console.log('onRouteUpdate');
    setTimeout(() => {
      setWindowVars();
      if (window.instantiatePage) {
        window.instantiatePage();
      }
    }, 20);
  }
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location }
}) => {
  window.history.scrollRestoration = 'manual';
  setTimeout(() => {
    if (location.hash) {
      // If hash (`/#something`), smooth scroll to that position
      const item = document.querySelector(`${location.hash}`);
      item?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, 0);

  // do not let gatsby do anything more
  return false;
};
